import { getToken } from "../../setup/api";

export default {
  user: null,
  course_info: null,
  notifications: [],
  certificateStatus: null,
  logged: !!getToken()
};
